import { render, staticRenderFns } from "./chulan.vue?vue&type=template&id=9c9fd804&scoped=true"
import script from "./chulan.vue?vue&type=script&lang=js"
export * from "./chulan.vue?vue&type=script&lang=js"
import style0 from "./chulan.vue?vue&type=style&index=0&id=9c9fd804&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c9fd804",
  null
  
)

export default component.exports